export default {
  namespaced: true,
  state: () => ({
    RetornaQTDPedidosDashPTC: {},
    RetornaQTDNotasDashPTC: {},
    top10Produtos: {},
    qtdTitulosDashboardPTC: [],
    setIsLoading: false,
    seriesPedido: [],
    labelsPedido: [],
    seriesTop10: [],
    labelsTop10: [],
    serversTitulos: [],
    labelsTitulos: [],
  }),
  actions: {},
  mutations: {
    SET_DASHBOARD(state, data) {
      state.RetornaQTDPedidosDashPTC = data.RetornaQTDPedidosDashPTC;
      state.RetornaQTDNotasDashPTC = data.RetornaQTDNotasDashPTC;
      state.top10Produtos = data.top10Produtos;
      state.qtdTitulosDashboardPTC = data.qtdTitulosDashboardPTC;
      state.seriesPedido = data.RetornaQTDPedidosDashPTC.seriesPedido;
      state.labelsPedido = data.RetornaQTDPedidosDashPTC.labelsPedido;
      state.seriesTop10 = data.top10Produtos.seriesTop10;
      state.labelsTop10 = data.top10Produtos.labelsTop10;
      state.serversTitulos = data.qtdTitulosDashboardPTC.serversTitulos;
      state.labelsTitulos = data.qtdTitulosDashboardPTC.labelsTitulos;
    },
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
    },
  },
  getters: {
    gePedidosDash: (state) => state.RetornaQTDPedidosDashPTC,
    getNotasDash: (state) => state.RetornaQTDNotasDashPTC,
    getTop10ProdutosDash: (state) => state.top10Produtos,
    getQtdTitulosDash: (state) => state.qtdTitulosDashboardPTC,
    getIsLoading: (state) => state.setIsLoading,
    getSeriesPedido: (state) => state.seriesPedido,
    getLabelsPedido: (state) => state.labelsPedido,
    getSeriesTop10: (state) => state.seriesTop10,
    getLabelsTop10: (state) => state.labelsTop10,
    getServersTitulos: (state) => state.serversTitulos,
    getLabelsTitulos: (state) => state.labelsTitulos,

  },

};
